var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ListIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 42
  }), React.createElement("path", {
    d: "M59.2174 0.130493H17.4783V8.47832H59.2174V0.130493Z"
  }), React.createElement("path", {
    d: "M9.13042 0.130493H0.782593V8.47832H9.13042V0.130493Z"
  }), React.createElement("path", {
    d: "M59.2174 16.826H17.4783V25.1739H59.2174V16.826Z"
  }), React.createElement("path", {
    d: "M9.13042 16.826H0.782593V25.1739H9.13042V16.826Z"
  }), React.createElement("path", {
    d: "M59.2174 33.5217H17.4783V41.8696H59.2174V33.5217Z"
  }), React.createElement("path", {
    d: "M9.13042 33.5217H0.782593V41.8696H9.13042V33.5217Z"
  }));
};
export var ListIconGlyph = function (props) {
  return React.createElement(ListIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};